import { ref } from "vue";

export const nameTableRef = ref('')